import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  selected: () => __(translations.monitoringCalendarSuppliersList.selected, `Selected ({{items}}/{{total}})`),
};
